const Icon = ({name}) => {
    return (
        <i className="material-symbols-rounded notranslate">{name}</i>
    )
};

export default Icon